import React from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { navigation } from "../../constants/ref";

import { color } from "../../constants/styles";
import { maxWidth } from "../sections/shared/styled";

interface MenuProps { }

const Menu: React.FC<MenuProps> = () => {
  const router = useLocation();

  return (
    <StyledList>
      {navigation.menu.map(({ link, label }) => (
        <li
          key={link}
          style={{
            color: router.pathname === link ? color.GREEN : color.GRAY_3,
          }}
        >
          <StyledLink to={link} onClick={() => window.scrollTo(0, 0)}>
            {label}
          </StyledLink>
        </li>
      ))}
    </StyledList>
  );
};

export default Menu;

const StyledList = styled.ul`
  display: flex;
  justify-content: center;
  gap: 16px;
  position: relative;
  font-weight: 500;
  font-size: 17px;
  line-height: 24px;

  ${maxWidth}
  width: 100%;
  li {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0px 0px;
    gap: 7px;
    height: 43px;
    width: 120px;
  }
`;
const StyledLink = styled(Link)`
  cursor: pointer;
  min-width: 80px;
  text-align: center;
`